import { useEffect } from 'react';

declare global {
    var rr_annotations_array: any;
    var rr_experience_browser: any;
    var RR_DEBUG: any;
}

export default function useAlgonomyBrowser(enable: boolean) {
    useEffect(() => {
        if (!enable) {
            return;
        }

        if (window.rr_annotations_array) {
            window.rr_annotations_array.push(window.RR_DEBUG.response.rr_annotations);
        } else {
            window.rr_annotations_array = [window.RR_DEBUG.response.rr_annotations];
        }

        if (window.rr_experience_browser) {
            window.rr_experience_browser.start();
            return;
        }

        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');

        script.src = '//cdn.richrelevance.com/dashboard/applications/cfrad/dist/index.min.js';
        script.async = true;

        head.appendChild(script);

        return () => {
            head.removeChild(script);
        };
    }, []);
}
